import {fetchSubStations} from "../../stageStatus/network/StageNetworkAPI";
import {readFilterState, saveFilterState} from "../../util/Util";
import {DEPART_FILTER_STATE_KEY} from "../../util/LocalStorageKeys";
import {DEPART_TAB_METRIC_KEY} from "../../util/MetricUtil";

export const DepartFilterReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_FILTER_DATA": {
            const newState = {...state, data: {...state.data, ...action.data}}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState
        }
        case "SELECT_CLUSTER": {
            const newState = {...state, cluster: action.Cluster}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState
        }
        case "SELECT_DRIVER_TYPE": {
            const newState = {...state, driverType: action.DriverType}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_STATUS": {
            const newState = {...state, status: action.status}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_DEPARTURE": {
            const newState = {...state, departure: action.Departure}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_DEPART_TIME": {
            const newState = {...state, departByTime: action.DepartByTime}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_VIEW_TYPE": {
            const newState = {...state, viewType: action.viewType}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "UNLOAD_VIEW":
            return state
        case "REMOVE_ALL_FILTER": {
            const newState = {...state};
            Object.entries(state).forEach(entry => {
                const key = entry[0];
                const values = entry[1];
                if (Array.isArray(values) && values.length && key !== 'data') {
                    newState[key] = [];
                }
            });
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "REMOVE_FILTER": {
            const {key, value} = action.data
            state[key] = state[key].filter(item => item !== value)
            const newItem = state[key].filter(item => item !== value)
            const newState = {...state, [key]: newItem}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState
        }
        case "LOAD_XPT_NODES":
            const {dispatcher, baseUrl, capability, stationConfig} = action.data;
            fetchSubStations(dispatcher, baseUrl, capability, DEPART_TAB_METRIC_KEY, stationConfig);
            return state;
        case "RECEIVE_XPT_NODES": {
            const {xptNodes} = action.data;
            const savedState = readFilterState(DEPART_FILTER_STATE_KEY);
            let newState = {...state, xptNodes, data: {...state.data, xptNodes}};
            if (savedState) {
                newState = {...state, data: {...state.data, xptNodes}};
            }
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_XPT_NODE": {
            const newState = {...state, xptNodes: action.xptNodes}
            saveFilterState(DEPART_FILTER_STATE_KEY, newState);
            return newState
        }
        case "LOAD_FILTERS": {
            const savedState = readFilterState(DEPART_FILTER_STATE_KEY);
            if (savedState) {
                return {
                    ...state,
                    ...savedState
                }
            }
            return state;
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/depart/reducers/DepartFilterReducer.js